import type { Warning } from '@/api/schemas';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/Icon';

const TONE: Record<Warning['severity'], string> = {
  info: 'border-running/30 bg-running/10 text-running',
  warning: 'border-awaiting/30 bg-awaiting/10 text-awaiting',
  error: 'border-failed/30 bg-failed/10 text-failed',
};
const ICON: Record<Warning['severity'], string> = { info: 'info', warning: 'warning', error: 'error' };

/** Non-fatal findings (`Warning[]`): code in mono + message, tinted by severity; unknown codes render the same. */
export function WarningsList({ warnings, className, compact }: { warnings: Warning[]; className?: string; compact?: boolean }) {
  if (warnings.length === 0) return null;
  return (
    <ul className={cn('flex flex-col gap-1.5', className)} aria-label="Warnings">
      {warnings.map((w, i) => (
        <li key={`${w.code}-${w.key ?? ''}-${i}`} data-testid={`warning-${w.code}`} className={cn('flex items-start gap-2 rounded-md border px-2.5 py-1.5 text-[13px]', TONE[w.severity], compact && 'py-1 text-xs')}>
          <Icon name={ICON[w.severity]} size={16} className="mt-px shrink-0" />
          <span className="min-w-0">
            <code className="mr-1.5 font-mono text-[11px] opacity-90">{w.code}</code>
            {w.key ? <code className="mr-1.5 font-mono text-[11px] opacity-90">{w.key}</code> : null}
            <span className="text-foreground/90">{w.message}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}
